import { Routes, Route, Navigate } from 'react-router-dom'
import Home from '../pages/Home'
import Shop from '../pages/Shop'
import Cart from '../pages/Cart'
import Login from '../pages/Login'
import ProductsDetails from '../pages/ProductsDetails'
import SignUp from '../pages/SignUp'
import Checkout from '../pages/Checkout'
import ProductedRoute from './ProductedRoute'

import AddProducts from '../admin/addProducts'
import AllProducts from '../admin/AllProducts'
import Dashboard from '../admin/Dashboard'

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="home" />} />
      <Route path="home" element={<Home />} />
      <Route path="shop" element={<Shop />} />
      <Route path="cart" element={<Cart />} />
      {/* <Route path="login" element={<Login />} /> */}
      {/* <Route path="signup" element={<SignUp />} /> */}

      <Route path="/*" element={<ProductedRoute />}>
        {/* <Route path="/checkout" element={<Checkout />} /> */}
        <Route path="dashboard/" element={<Dashboard />} />
        <Route path="dashboard/all-products" element={<AllProducts />} />
        <Route path="dashboard/add-products" element={<AddProducts />} />
      </Route>
      <Route
        path="checkout"
        element={
          <ProductedRoute>
            <Checkout />
          </ProductedRoute>
        }
      />
      <Route path="shop/:id" element={<ProductsDetails />} />
    </Routes>
  )
}

export default Router
